import { Avatar, Checkbox, ListItem } from '@mui/material';
import { Checkmark, CheckmarkChecked } from 'Images';

interface ICityOption {
  option: string;
  isSelected: boolean;
  selectCity: Function;
}

export const CityOption = ({ option, isSelected, selectCity }: ICityOption) => {
  return (
    <ListItem
      sx={{
        maxHeight: '40px',
        fontWeight: isSelected ? '700 !important' : '400 !important',
        fontSize: '18px',
        lineHeight: '22px',
        '&:hover': {
          bgcolor: 'primary.shade_100',
          cursor: 'pointer',
        },
        '&.Mui-selected': {
          fontWeight: '400 !important',
          bgcolor: 'primary.shade_100',
        },
      }}
      onClick={() => (selectCity ? selectCity(option) : undefined)}
    >
      <Checkbox
        icon={
          <Avatar
            alt=''
            src={Checkmark}
            sx={{ width: '24px', height: '24px' }}
          />
        }
        checkedIcon={
          <Avatar
            alt=''
            src={CheckmarkChecked}
            sx={{ width: '24px', height: '24px' }}
          />
        }
        checked={isSelected}
      />
      {option}
    </ListItem>
  );
};
